import {Component, Input} from '@angular/core';
import {NgIf} from "@angular/common";
import {BrowserService} from "@services/components/browser.service";

@Component({
  selector: 'app-delivery-info',
  standalone: true,
    imports: [
        NgIf
    ],
  templateUrl: './delivery-info.component.html',
  styleUrl: './delivery-info.component.scss'
})
export class DeliveryInfoComponent {
  @Input() data!: {value: any,useType: string, type: 'deliveryTime' | 'deliveryPrice'};
  isMobile = false;

  constructor(
    private browserService: BrowserService,
  ) {
    this.isMobile = this.browserService.isMobileDevice;
  }
}
